import React from 'react'
import { Grid } from '@material-ui/core'
import MyTextfield from '../../../control/textfield/textfield'
import { validateNumeralNoPrecision } from '../../../utilities/validate'
import useTranslate from '../../../i18n/useTranslate'

const DocumentDeadlineForm: React.FC = () => {
    const translate = useTranslate()
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <MyTextfield
                    name="fullBoard"
                    materialInputProps={{
                        label: translate.get('UM.SETTING_SYSTEM.FULL_BOARD'),
                        placeholder: translate.get('UM.SETTING_SYSTEM.FULL_BOARD'),
                        size: 'small',
                    }}
                    validates={[validateNumeralNoPrecision(translate.get('MESSAGE.M005'))]}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <MyTextfield
                    name="expedite"
                    materialInputProps={{
                        label: translate.get('UM.SETTING_SYSTEM.EXPEDITE'),
                        placeholder: translate.get('UM.SETTING_SYSTEM.EXPEDITE'),
                        size: 'small',
                    }}
                    validates={[validateNumeralNoPrecision(translate.get('MESSAGE.M005'))]}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <MyTextfield
                    name="exempt"
                    materialInputProps={{
                        label: translate.get('UM.SETTING_SYSTEM.EXEMPT'),
                        placeholder: translate.get('UM.SETTING_SYSTEM.EXEMPT'),
                        size: 'small',
                    }}
                    validates={[validateNumeralNoPrecision(translate.get('MESSAGE.M005'))]}
                />
            </Grid>
        </Grid>
    )
}

export default DocumentDeadlineForm
